

function ListController(GridVolatileStateManager, GridPersistentStateManager, GridTabsManager, $scope, $q, $uibModal, $timeout, GridId, BaseFilter, EffectiveTime, Class, SimpleObservable, $injector) {
	var self = this;
	

	this.Class = Class;  // Person
	this.gridId = GridId;
	this.baseFilter = BaseFilter;
	this.effectiveTime = EffectiveTime;
	this.promises = {};  // a place to store all deferred dependencies of the grid
	this.promisesDefer = {};  // a place to store matching defered for promises
	self.loading = false;
	
	this.session = GridVolatileStateManager.get(this.gridId);
	this.promises.prefs = GridPersistentStateManager.load(this.gridId.replace(/0-9/, '')).then(function(prefs){
		self.prefs = prefs;
		return prefs;
	});
	
	this.params = {
		filter: this.session.getItem('filter', {}),
		base_filter: this.baseFilter,
		sort: this.session.getItem('sort', [this.Class.default_sort]),
		limit: this.session.getItem('limit', 50),
		offset: this.session.getItem('offset', 0),
		effective_time: this.effectiveTime || null,
		group: {0:'list',1:'essential'},
		levels: 1
	};
	this.state = this.session.getItem('state', {});
	this.filterQuerySelector = this.Class.get_text_search_query();
	this.filterQuery = this.params.filter[this.filterQuerySelector];
	this.loadCounter = 0;
	this.objects_count = {};
	this.objects = [];  // lista oiektów
	this.message = null;
	this.options = [  // lista ekranów do panelu z opcjami
		/*{'title': 'Zakładki wyszukiwania', 'templateUrl': 'grid/options-tabs.html'}*/
	]
	
	
	this.failure = function(error) {
		self.message = {type:'danger', body:error.data.message}
		self.loading = false;
		if (error.data.code == 401) {
			$scope.$emit('unauthorized');
		}
	}
	
	this.saveSession = function() {
		self.session.setItem({
			filter: self.params.filter,
			sort: self.params.sort,
			limit: self.params.limit,
			offset: self.params.offset,
			state: self.state,
		});
	}
	
	this.reload = function() {
		return self.getPage();
	}
	
	this.getPage = SimpleObservable(function() {
		self.loadCounter++;
		self.loading = true;
		var currentLoad = self.loadCounter;
		var params = angular.copy(self.params);
		//if (self.tabs) self.tabs.searchChanged(params.filter);  // tabs
		self.objects_count = {}
		// count objects
		return self.Class.count({
			filter:angular.copy(params.filter), 
			base_filter:angular.copy(params.base_filter), 
			effective_time: params.effective_time
		}).then(function(objects_count){
			if (self.loadCounter != currentLoad) {
				// jest już wczytywana nowsza wersja, pomińmy te wyniki
				//self.objects = [];
				return self.objects;
			}
			self.objects_count = objects_count;
			self.saveSession();
			// fetch objects if count > 0
			self.objects = [];
			self.message = null;
			
			angular.extend(params.filter, params.base_filter); 
			if (objects_count.filtered > 0) {
				return self.Class.find(params).then(function(list){
					if (self.loadCounter != currentLoad) {
						// jest już wczytywana nowsza wersja, pomińmy te wyniki
						return self.objects;
					}
					self.loading = false;
					return self.objects = list;
				});
			} else {
				self.loading = false;
				return self.objects;
			}
		}).catch(self.failure);
	})
	
	//$timeout(function(){console.debug("Waiting for promises", self.promises); $q.all(self.promises).then(function(){console.debug("List promises loaded!")});});
	$timeout(function(){$q.all(self.promises).then(self.getPage);});
	
	// apply text search
	this.setFilterQuery = function() {
		if (self.filterQuery) {
			self.params.filter[self.filterQuerySelector] = self.filterQuery.replace(/[^0-9A-Za-z\u00C0-\u017F @_\-.]/g, '');  //  + Latin 1 + Latin A + Latin B, http://kourge.net/projects/regexp-unicode-block
		} else {
			delete self.params.filter[self.filterQuerySelector];
		}
		self.setFilter(self.params.filter);  // fire event
		self.getPage()
	}
	
	
	this.setRowsPerPage = function(n) {
		this.params.limit = n;
	}
	this.setFilter = SimpleObservable(function(filter) {
		this.params.filter = filter;
		self.filterQuery = filter[self.filterQuerySelector] || '';
		return filter
	});
	
	// przeładowanie wywołane przez nadrzędny obiekt
	$scope.$on('object-reload', function(){
		// zamknięcie formularza
		console.log('Reloading list..');
    	self.getPage();
    });
    
    $scope.$on('search', function(event, search_string) {
		self.filterQuery = search_string;
	});

	this.waitFor = function(componentName) {
		console.log('Setting wait for: ' + componentName);
		self.promisesDefer[componentName] = $q.defer();
		self.promises[componentName] = self.promisesDefer[componentName].promise;
	}

	this.stopWaitingFor = function(componentName) {
		console.log('Stopping wait for: ' + componentName);
		self.promisesDefer[componentName].resolve(true);
	}
	
	this.isExportAvailable = function() {
		var export_config = self.Class.export_config || {};
		var has_default_export_config = export_config.default;
		return has_default_export_config;
	}
    
    this.export = function(format) {
		var filter = {};
    	angular.extend(filter, self.params.filter);
    	angular.extend(filter, self.params.base_filter);
		var url = self.Class.get_url('export_all', {format:format, filter:filter, sort:self.params.sort, preset: 'default'});
		window.location = url;
    }
    
    this.showPrefs = function() {
		
		var save = function(data) {
			function doSave(i) {
				var option = self.options[i];
				return option.save().then(function(){
					if (i < self.options.length - 1) {
						return doSave(i+1);
					} else {
						return true;
					}
				});
			}
			if (self.options.length > 0) {
				return doSave(0);
			} else {
				return $q.when(true);
			}
		}
		//var dlg = dialogs.create('partials/grid/dialog-save-tab.html','SaveCancelDialogCtrl',{data:tab,save:save},{size:'lg'});
		var dlg = $uibModal.open({
		      animation: true,
		      templateUrl: 'framework/partials/grid/dialog-grid-options.html',
		      controller: 'SubmitCancelDialogCtrl as dCtrl',
		      size: 'lg',
		      resolve: {
		        params: function () {
		          return {options:self.options, lCtrl: self, submit:save}
		        }
		      }
		});
	}


	this.activate_module_action = function(action) {
		return $injector.invoke(action.action, null, {Class:self.Class});
	}
    
	
	window.lCtrl = this;  // debug

}


// a state controller for the new Grid components
function ModuleListController(ListContext, BaseFilter, $state) {
	var self = this;

	this.ListContext = ListContext;
	this.BaseFilter = BaseFilter;
	this.Class = ListContext.getClass();  // Person
	this.predefinedFilters = ListContext.getPredefinedFilters();
	this.mergeGridColumnDefs = ListContext.getMergeGridColumnDefs();
	this.EffectiveTime = ListContext.getEffectiveTime();  // null
	this.title = ListContext.getListTitle();
	this.name = ListContext.getName();
	this.icon = ListContext.getIcon();
	this.createLabel = ListContext.getCreateLabel();
	this.gridId = ListContext.Parent? (this.name + '-' + ListContext.Parent.getClass().name) : this.name;
	
	
	this.gotoObject = function(vid, event/*=null*/) {
		if(event && (event.ctrlKey || event.metaKey)){
			var url = $state.href('module.detail', {page: ListContext.config.name, vid: vid});
			window.open(url,'_blank');
		}else{
			$state.go('module.detail', {page: ListContext.config.name, vid: vid});
		}
	}
    
    this.can_create_from_context = function(parentContext) {
		//return self.ListContext.config.foreignKey;
		return self.ListContext.config.defaults;
    }
    
    this.gotoCreate = function(parentContext, parentObject) {
    	var params = {}
    	if (parentObject && parentContext && this.can_create_from_context(parentContext)) {
    		params.page = parentContext.getName();
    		params.parentVid = parentObject.__vid;
    		params.refClass = self.Class.name;
    	} else {
    		params.page = this.ListContext.getName();
    	}
    	console.log('Create screen', "module.create", params);
    	$state.go("module.create", params);
    }
	
	window.mCtrl = this;  // debug
}




angular.module('admin')
.controller('ListController', ListController)
.controller('ModuleListController', ModuleListController)
